<script lang="ts" setup>
defineProps<{
  helpText: string
}>()
</script>

<template>
  <small class="block text-xs font-normal text-gray-500 dark:text-gray-400">{{ helpText }}</small>
</template>
